// extracted by mini-css-extract-plugin
export default {"btnInput":"_2OUTpR8zkr8NpESJ3gmZRu"};